import {
  RESET_USERS,
  RESET_USER,
  RESET_ERROR,
  GET_USERS,
  SET_USERS,
  API_ERROR,
  GET_USER,
  SET_USER,
  CREATE_USER,
  CREATE_USER_SUCCESS,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  ACTIVATE_USER,
  ACTIVATE_USER_SUCCESS,
  RESET_USER_PASSWORD,
  RESET_USER_PASSWORD_SUCCESS
} from "./actionTypes";

export const resetUserPassword = (password, repeatPassword, userId, companyId) => {
  return {
    type: RESET_USER_PASSWORD,
    payload: {password, repeatPassword, userId, companyId},
  };
}

export const setResetUserPasswordSuccess = (message) => {
  return {
    type: RESET_USER_PASSWORD_SUCCESS,
    payload: {message},
  };
}

export const resetUsers = () => {
  return {
    type: RESET_USERS,
    payload: {},
  };
};

export const resetUser = () => {
  return {
    type: RESET_USER,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getUsers = (idCompany, page, qnt, name, email, isForm ) => {
  return {
    type: GET_USERS,
    payload: { idCompany, page, qnt, name, email, isForm  },
  };
};
export const setUsers = (data, qtdDefault, idCompany) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_USERS,
    payload: { ...data, paging, idCompany },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createUser = (newUserValues, idCompany) => {
  return {
    type: CREATE_USER,
    payload: { newUserValues, idCompany },
  };
};
export const createUserSuccess = (message) => {
  return {
    type: CREATE_USER_SUCCESS,
    payload: { message },
  };
};

export const getUser = (idUser, idCompany, isForm) => {
  return {
    type: GET_USER,
    payload: { idUser, idCompany, isForm },
  };
};
export const setUser = (data) => {
  return {
    type: SET_USER,
    payload: { data },
  };
};
export const editUser = (idUser, newUserValues, idCompany) => {
  return {
    type: EDIT_USER,
    payload: { idUser, newUserValues, idCompany },
  };
};
export const editUserSuccess = (message) => {
  return {
    type: EDIT_USER_SUCCESS,
    payload: { message },
  };
};

export const activateUser = (idUser, active, idCompany) => {
  return {
    type: ACTIVATE_USER,
    payload: { idUser, active, idCompany },
  };
};
export const activateUserSuccess = (message) => {
  return {
    type: ACTIVATE_USER_SUCCESS,
    payload: { message },
  };
};
